import { Wrapper } from '@american-autonomy/ag-ui';

import type { CardContent, FunctionComponent } from './types';

import styles from './styles.module.scss';

type CeilingRowProps = {
    content: CardContent;
};

const CeilingRow: FunctionComponent<CeilingRowProps> = ({ content }) => {
    if (content.ceilingDisplay === null) {
        return null;
    }

    if (content.ceilingDisplay.kind === 'unknown') {
        return (
            <Wrapper className={`${styles.ceilingRow} ${styles.ceilingRowUnknown}`}>
                {content.ceilingDisplay.text}
            </Wrapper>
        );
    }

    return (
        <Wrapper className={styles.ceilingRow}>
            <span className={styles.ceilingValue}>{content.ceilingDisplay.valueText}</span>

            <span className={styles.ceilingSuffix}>{content.ceilingDisplay.suffixText}</span>
        </Wrapper>
    );
};

export default CeilingRow;
